export default __webpack_public_path__ + "static/media/d.2a3fa731.svg";